// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function TreePalmBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M30.086 6.309a8.858 8.858 0 0 0-12.942 0c-.428.45-.811.94-1.144 1.465a9.569 9.569 0 0 0-1.144-1.465 8.858 8.858 0 0 0-12.942 0 1.5 1.5 0 0 0 .487 2.41l5.849 2.546A9.431 9.431 0 0 0 2.821 22.39a1.5 1.5 0 0 0 2.357.801l9.322-7.097V28a1.5 1.5 0 0 0 3 0V16.094l9.317 7.098a1.5 1.5 0 0 0 2.357-.8 9.431 9.431 0 0 0-5.429-11.126l5.854-2.546a1.5 1.5 0 0 0 .487-2.41v-.001ZM8.385 6.5a5.895 5.895 0 0 1 4.297 1.875 6.55 6.55 0 0 1 1.355 2.135L6 7.012A5.785 5.785 0 0 1 8.385 6.5ZM5.549 19.144a6.465 6.465 0 0 1 4.767-5.423 6.607 6.607 0 0 1 2.57-.162L5.55 19.144Zm20.076-2.418c.434.743.713 1.565.821 2.418l-7.321-5.586a6.527 6.527 0 0 1 2.564.163 6.452 6.452 0 0 1 3.936 3.005Zm-7.663-6.216a6.553 6.553 0 0 1 1.355-2.135A5.896 5.896 0 0 1 23.615 6.5c.822 0 1.636.174 2.385.512l-8.038 3.498Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
